export const calculateRTP = (probability: number, multiplier: number): number => {
  if (probability <= 0 || probability > 1) {
    console.error("Probability must be between 0 and 1")
    return 0
  }

  return (multiplier * probability) * 100 // Convert to percentage
}